import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Challenges from './challenges';
// import LiveEvents from './live-events';
import Milestones from './milestones';
import './index.scss';
import {
  setToolbarTitle,
  hideModality,
  showModality,
} from '../../../store/to-native';
import useToolbarTitle from '@ifit/hooks/useToolbarTitle';
import { TrophyTabs, WithTrophySlug } from '../../routes';
import {
  // liveEventsTabTitle,
  milestonesTabTitle,
  myChallengesTitle,
  trophyCaseTitle,
} from '../../../i18n/translations';
import NavigationTabs from '../../../components/navigation-tabs';
import { useConfig } from '../../../store/reducers/config';
import nativeBridge from '@ifit/native-webview-interface';
import { setItem } from '../../../helpers/local-storage';

const TrophyCase: React.FC = () => {
  const { trophySlug } = useParams<WithTrophySlug>();
  const { platform } = useConfig();
  setItem('trophy-case-entry', true);

  useToolbarTitle(trophyCaseTitle(), {
    buttonStyle: 'hamburger',
  });

  const tabs = useMemo(() => {
    return [
      {
        name: myChallengesTitle(),
        link: '/trophy-case/challenges',
        selected: trophySlug === TrophyTabs.challenges || !trophySlug,
      },
      // Temp removed
      // {
      //   name: liveEventsTabTitle(),
      //   link: '/trophy-case/live-events',
      //   selected: trophySlug === TrophyTabs.liveEvents,
      // },
      {
        name: milestonesTabTitle(),
        link: '/trophy-case/milestones',
        selected: trophySlug === TrophyTabs.milestones,
      },
    ];
  }, [trophySlug]);

  useEffect(() => {
    setToolbarTitle(trophyCaseTitle());
    hideModality();
    return () => {
      showModality();
    };
  }, []);

  useEffect(() => {
    if (['ios', 'ipados'].includes(platform)) {
      const enableScrollInterval = setInterval(() => {
        nativeBridge.callNative({
          methodName: 'ScrollView',
          isScrollEnabled: 'true',
        });
      }, 1000);
      return () => clearTimeout(enableScrollInterval);
    }
  }, [platform]);

  let selectedTab = null;
  switch (trophySlug) {
    // Temp removed
    // case TrophyTabs.liveEvents:
    //   selectedTab = <LiveEvents></LiveEvents>;
    //   break;
    case TrophyTabs.milestones:
      selectedTab = <Milestones></Milestones>;
      break;
    default:
      selectedTab = <Challenges></Challenges>;
  }
  return (
    <div className="trophy-case">
      <NavigationTabs tabs={tabs}></NavigationTabs>
      {selectedTab}
    </div>
  );
};

export default TrophyCase;
